import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50b9c50d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=50b9c50d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b9c50d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b9c50d')) {
      api.createRecord('50b9c50d', component.options)
    } else {
      api.reload('50b9c50d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=50b9c50d&scoped=true&", function () {
      api.rerender('50b9c50d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/index.vue"
export default component.exports